<template>
  <b-nav justified class="">
    <div class="container-fluid initiatives-nav">
      <div class="container">
        <div class="row">
          <div class="col">
            <b-nav-item :to="{ name: 'HolidayAtHome' }">
              {{ $t("title.holiday") }}
            </b-nav-item>
          </div>
          <div class="col">
            <b-nav-item :to="{ name: 'GlobalVisibility-MissYouToo' }" :active="gv">
              {{ $t("title.gv") }}</b-nav-item
            >
          </div>
          <div class="col">
            <b-nav-item :to="{ name: 'GearingUpTheTrade-Uncease' }" :active="gear">
              {{ $t("title.gearing") }}
            </b-nav-item>
          </div>
        </div>
      </div>
    </div>
  </b-nav>
</template>

<script>
export default {
  name: "InitNav",
  props: {
    gv: Boolean,
    gear: Boolean,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.router-link-exact-active {
  background-color: #e81b29;
  color: #fff !important;
}
@media (max-width: 767px) {
  .initiatives-nav {
    display: none;
  }
}
</style>
